import React from 'react'
import DefaultStyleContainer from '../../../Components/Buttons/DefaultStyle'

export default function DefaultStyle() {
  return (
    <div className='page-body'>
        <DefaultStyleContainer/>
    </div>
  )
}
